/* import __COLOCATED_TEMPLATE__ from './action-item-complete-popover.hbs.js'; */
import SetupGuideLeaveModal from '@dashboard/shared-ui/components/setup-guide/leave-modal';
import Component from '@ember/component';
import { inject as service } from '@ember/service';
import { actionItemCompletePopoverClose } from '@dashboard/shared-ui/events/setup-guide/event-catalog';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  eventstream: service(),
  modal: service(),
  setupGuide: service(),
  popoverClasses: 'popover--walkthrough--expanded popover--walkthrough--dark',
  actions: {
    close() {
      this.eventstream.track(actionItemCompletePopoverClose(this.step?.name));
      return this.modal.open(SetupGuideLeaveModal);
    }
  }
});